import { apiSlice } from "./ApiSlice";

const treatmentPlanApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addTreatmentPlan: builder.mutation({
      query: (data) => ({
        url: "/api/DoctorProfile/Add-TreatmentPlan",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["TreatmentPlan"],
    }),
    getTreatmentPlans: builder.query({
      query: ({ appointmentID, patientUserUniqueID, userClinicID }) => ({
        url: `/api/DoctorProfile/GetTreatmentPlanDetails?appointmentID=${appointmentID}&patientUserUniqueID=${patientUserUniqueID}&userClinicID=${userClinicID}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useAddTreatmentPlanMutation, useLazyGetTreatmentPlansQuery } =
  treatmentPlanApiSlice;
